import type { SearchSavedSearchElasticSchemaNullablePatched } from '@iconik-io/iconik-api/src/schema_patched/saved_search';
import type { SearchSavedSearchSchema } from '@iconik-io/iconik-api/src/services/search';

export const savedSearchElasticToSavedSearch = (
  savedSearchResults: SearchSavedSearchElasticSchemaNullablePatched,
): SearchSavedSearchSchema => ({
  id: savedSearchResults.id,
  name: savedSearchResults.name,
  criteria: savedSearchResults.criteria ?? {},
  date_created: savedSearchResults.date_created ?? undefined,
  date_modified: savedSearchResults.date_modified ?? undefined,
  group_id: savedSearchResults.group_id ?? undefined,
  permissions: savedSearchResults.permissions ?? undefined,
});
